import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IZone } from './interfaces';

export const getZoneList = (data: IDynamicTableParams) => {
  return instance()
    .post<IZone[]>('/zone/list', data)
    .then((response) => response.data);
};

export const getZoneAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/zone/availableColumns')
    .then((response) => response.data);
};

export const getZoneAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/zone/availableGroupColumns')
    .then((response) => response.data);
};

export const loadZone = (zoneId: number) => {
  return instance()
    .get<IZone>('/zone/load/' + zoneId)
    .then((response) => response.data);
};

export const createZone = (zone: IZone) => {
  return instance()
    .post<IZone>('/zone/save', zone)
    .then((response) => response.data);
};

export const updateZone = (zone: IZone) => {
  return instance()
    .post<IZone>(`/zone/${zone.zoneId}/update`, zone)
    .then((response) => response.data);
};

export const deleteZone = (zoneId: number) => {
  return instance()
    .post('/zone/archive', { zoneId })
    .then((response) => response.data);
};

export const recoverZone = (zoneId: number) => {
  return instance()
    .post('/zone/recover', { zoneId })
    .then((response) => response.data);
};
